export default __webpack_public_path__ + "static/media/canstake.3c94f890.svg";